module.exports = __webpack_public_path__ + "media/staff/milos-8777bb53.png";